import { Box, IconButton } from '@mui/material';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';

interface VideoPlayerProps {
  videoId: string;
  onNextVideo?: () => void;
  onPreviousVideo?: () => void;
  videoIndex: number;
  numberOfVideos: number;
  showControlBtn?: boolean;
  mute?: boolean;
  source?: string;
  isLive?: boolean;
}

export const VideoPlayer = ({
  videoId,
  onNextVideo,
  onPreviousVideo,
  videoIndex,
  numberOfVideos,
  showControlBtn = true,
  mute = false,
  source = 'youtube',
  isLive = false,
}: VideoPlayerProps) => {
  if (!videoId) return null;

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      <Box sx={{ position: 'relative', paddingTop: '56.25%', width: '100%', height: '90%' }}>
        <iframe
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          src={
            isLive
              ? `https://www.youtube.com/embed/live_stream?channel=UCmyBe-R7Do6ZGWLyaStSosg&autoplay=1&muted=${mute}`
              : source === 'vimeo'
              ? `https://player.vimeo.com/video/${videoId}?app_id=122963&autoplay=1&muted=${mute}`
              : `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=${mute}`
          }
          allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
      {showControlBtn && (
        <>
          <IconButton
            title="Next Video"
            onClick={onNextVideo}
            disabled={videoIndex === numberOfVideos - 1}
            sx={{
              float: 'right',
              backgroundColor: 'rgba(0,0,0,0.6)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            }}
          >
            <SkipNextIcon />
          </IconButton>
          <IconButton
            title="Previous Video"
            onClick={onPreviousVideo}
            disabled={videoIndex === 0}
            sx={{
              float: 'left',
              backgroundColor: 'rgba(0,0,0,0.6)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            }}
          >
            <SkipPreviousIcon />
          </IconButton>
        </>
      )}
    </Box>
  );
};
